var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mountDom
    ? _c(
        "mounting-portal",
        { attrs: { "mount-to": _vm.mountingTarget, append: "" } },
        [
          _c(
            "transition",
            {
              attrs: {
                "enter-active-class": "v-easy-dialog--transition-ease-in",
                "enter-class": "v-easy-dialog--opacity-0",
                "enter-to-class": "v-easy-dialog--opacity-100",
                "leave-active-class": "v-easy-dialog--transition-ease-out",
                "leave-class": "v-easy-dialog--opacity-100",
                "leave-to-class": "v-easy-dialog--opacity-0"
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOpen,
                      expression: "isOpen"
                    }
                  ],
                  staticClass: "v-easy-dialog--backdrop",
                  class: _vm.backdropClass,
                  style: _vm.backdropStyle,
                  attrs: { role: "dialog", "aria-hidden": !_vm.isOpen }
                },
                [
                  _c(_vm.backgroundBtnTag, {
                    tag: "component",
                    staticClass: "v-easy-dialog--backdrop-btn",
                    attrs: { tabindex: "-1" },
                    on: { click: _vm.attemptClose }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "dialogContent",
                      staticClass: "v-easy-dialog--content-container",
                      class: {
                        "v-easy-dialog--content-grow": _vm.growContent,
                        "v-easy-dialog--persist": _vm.showPersistence,
                        "v-easy-dialog--fullscreen": _vm.fullscreen
                      },
                      style: {
                        width: _vm.fullscreen ? "100%" : _vm.width,
                        maxHeight: _vm.fullscreen ? "100%" : _vm.maxHeight,
                        "max-width": !_vm.fullscreen && "90%"
                      },
                      attrs: {
                        tabindex: "-1",
                        id: "v-easy-dialog--content-" + _vm._uid,
                        role: "document"
                      }
                    },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            "enter-active-class":
                              "v-easy-dialog--transition-ease-in",
                            "enter-class":
                              "v-easy-dialog--content-transition-closed",
                            "enter-to-class":
                              "v-easy-dialog--content-transition-opened",
                            "leave-active-class":
                              "v-easy-dialog--transition-ease-out",
                            "leave-class":
                              "v-easy-dialog--content-transition-opened",
                            "leave-to-class":
                              "v-easy-dialog--content-transition-closed"
                          },
                          on: {
                            "after-enter": _vm.attemptFocus,
                            "after-leave": function($event) {
                              _vm.mountDom = false
                            }
                          }
                        },
                        [
                          _vm.isOpen
                            ? _vm._t("default", null, {
                                deactivate: _vm.attemptClose
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }